export default __webpack_public_path__ + "images/arrowRightWhite.v-1a2fda0d2cd08950608d2c3403d30339.svg";